import { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl';

interface RadiusCircleProps {
  latitude: number;
  longitude: number;
  radiusMiles: number;
}

// Convert miles to meters
const MILES_TO_METERS = 1609.344;

// Create a GeoJSON circle polygon
function createCircle(
  centerLng: number,
  centerLat: number,
  radiusMiles: number,
  points = 64
): GeoJSON.Feature<GeoJSON.Polygon> {
  const radiusMeters = radiusMiles * MILES_TO_METERS;
  const coords: [number, number][] = [];

  for (let i = 0; i <= points; i++) {
    const angle = (i * 360) / points;
    const dx = radiusMeters * Math.cos((angle * Math.PI) / 180);
    const dy = radiusMeters * Math.sin((angle * Math.PI) / 180);

    // Convert meters to degrees
    const lat = centerLat + (dy / 111320);
    const lng = centerLng + (dx / (111320 * Math.cos((centerLat * Math.PI) / 180)));
    coords.push([lng, lat]);
  }

  return {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [coords],
    },
  };
}

export function RadiusCircle({ latitude, longitude, radiusMiles }: RadiusCircleProps) {
  const geojson = useMemo(
    () => createCircle(longitude, latitude, radiusMiles),
    [latitude, longitude, radiusMiles]
  );

  return (
    <Source id="radius-circle" type="geojson" data={geojson}>
      <Layer
        id="radius-fill"
        type="fill"
        paint={{
          'fill-color': '#4F46E5',
          'fill-opacity': 0.08,
        }}
      />
      <Layer
        id="radius-line"
        type="line"
        paint={{
          'line-color': '#4F46E5',
          'line-width': 2,
          'line-opacity': 0.4,
          'line-dasharray': [4, 2],
        }}
      />
    </Source>
  );
}
